/**
 * * Enum del user admin
 */
export enum USERADMIN {
   ROLE = 'ADMIN'
}
